/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import RequireForAccess from 'react-access';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';

import ActionsList from 'components/ActionsList/ActionsList';

import { actionsOnAccountUsers } from 'permissions/account';

import { actionsListManageUsers } from '../actionsListData.js';

import AssetsProjectsCount from '../AssetsProjectsCount/AssetsProjectsCount';

import { ElectroTooltip } from 'components/ExtendedUiElements/customized';

import styles from './UserMoreOptionsList.module.scss';

export type TypeProps = {
  user: Object,
  accountStore: *,
};

@translate()
@inject('routing', 'accountStore')
@observer
export default class UserMoreOptionsList extends React.Component<*> {
  handleExpandUserChange = (user: number) => (ev: SyntheticInputEvent<*>, expanded: boolean) => {
    this.props.onExpandUserChange(user, expanded);
  };

  render(): React.Element<*> {
    const { user, t }: TypeProps = this.props;
    const currentPath: string = this.props.routing.location.pathname;
    const linkToSpecificUser: Object = {
      pathname: `${currentPath}/user/${user.id}`,
    };
    const activeClass: string = this.props.expandedUser === user.id ? styles.activeDropdown : '';

    return (
      <ExpansionPanel
        className={`${styles.userExpansionPanel} ${activeClass}`}
        expanded={this.props.expandedUser === user.id}
        onChange={this.handleExpandUserChange(user.id)}
      >
        <ExpansionPanelSummary
          className={styles.userExpansionPanelSummary}
          expandIcon={
            <ElectroTooltip title={t('general:options')}>
              <IconButton className={styles.userExpansionButton}>
                <svg>
                  <use xlinkHref="#icon-more-options" />
                </svg>
              </IconButton>
            </ElectroTooltip>
          }
        >
          <ListItem className={styles.userListItemHeader}>
            <ListItemText
              className={`${styles.userListItemText} ${!user.is_enabled ? styles.disabled : ''}`}
              primary={
                <ElectroTooltip title={t('general:users.user_disabled')} disabled={user.is_enabled}>
                  <Link to={linkToSpecificUser}>{`${user.first_name} ${user.last_name}`}</Link>
                </ElectroTooltip>
              }
              secondary={
                <AssetsProjectsCount
                  assetsCount={user.assets_count}
                  projectsCount={user.projects_count}
                />
              }
            />
          </ListItem>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={styles.userExpansionPanelDetails}>
          <List component="ul" disablePadding={true}>
            <ListItem>
              <Link to={linkToSpecificUser}>
                <svg>
                  <use xlinkHref="#icon-view-user-details" />
                </svg>
                <span>{t('general:actions.view_user_details')}</span>
              </Link>
            </ListItem>
            <RequireForAccess permissions={actionsOnAccountUsers[user.role_id]}>
              <ActionsList actions={actionsListManageUsers} data={user} accordionList={true} />
            </RequireForAccess>
          </List>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}
